module.exports = __webpack_public_path__ + "assets/img/join2021_010.f9c79369.png";